import useProfileCommonStore from './use-profile-common-store';
import { PROFILE_API_TYPES } from '../../hooks/api/_constants';

import {
  useProfileAssetAllocation,
  useProfileDisclosures,
  useProfileFeesExpenses,
  useProfileInvestmentFacts,
  useProfileInvestmentHoldings,
  useProfileInvestmentStrategy,
  useProfileMarketCapitalization,
  useProfileMaturityAllocation,
  useProfileMorningstarFactsRatings,
  useQuote
} from '../../hooks/api';
import useParticipantHoldingsStore from './use-participant-holdings-store';

const useVariableAnnuityTiaaAccessNonPropStore = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  // TIAA-8017: feesExpenses and morningstarFactsRatings endpoints were not built
  // for non-prop, but treat as prop.  So overriding these calls go to prop.
  const apiConfigProp = { ...apiConfigBase, apiType: PROFILE_API_TYPES.prop };

  return {
    ...commonState,
    assetAllocation: useProfileAssetAllocation(apiConfigBase),
    disclosureList: useProfileDisclosures({ ...apiConfigBase, forPrint: true }),
    feesExpenses: useProfileFeesExpenses(apiConfigProp),
    investmentFacts: useProfileInvestmentFacts(apiConfigBase),
    investmentHoldings: useProfileInvestmentHoldings(apiConfigBase),
    investmentStrategy: useProfileInvestmentStrategy(apiConfigBase),
    marketCapitalization: useProfileMarketCapitalization(apiConfigBase),
    maturityAllocation: useProfileMaturityAllocation(apiConfigBase),
    morningstarFactsRatings: useProfileMorningstarFactsRatings(apiConfigProp),
    participantHoldings: useParticipantHoldingsStore({ apiConfigBase, commonState }),
    quote: useQuote(apiConfigBase)
  };
};

export default useVariableAnnuityTiaaAccessNonPropStore;
